import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { PageSubTitle, PageTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { useHistory } from 'react-router-dom';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';
import { BannerSection } from '../../containers/BannerSection';
import { useAddOnsPage } from '../../hooks/utilities/useAddOnsPage';
import { AddOnsList } from './AddOnsList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AddOnsPage = () => {
  useDocumentTitle('add-ons');
  const history = useHistory();
  const {
    showAddonsPage
  } = useAddOnsPage();
  useEffect(() => {
    // TODO: Redirect to / and let the recommended engine handle the redirect once we build it in V2
    if (!showAddonsPage) {
      history.push('/marketing');
    }
  }, [history, showAddonsPage]);
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "ADD_ONS_PAGE_V2",
    children: [/*#__PURE__*/_jsx(BannerSection, {
      screen: "ADD_ONS"
    }), /*#__PURE__*/_jsxs(View, {
      as: "main",
      textAlign: "center",
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsx(PageTitle, {
        "aria-level": 1,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.products.tabs.add-ons.pageTitle"
        })
      }), /*#__PURE__*/_jsx(PageSubTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.products.tabs.add-ons.description"
        })
      }), /*#__PURE__*/_jsx(PageSection, {
        children: /*#__PURE__*/_jsx(View, {
          paddingBlock: "400",
          textAlign: "left",
          children: /*#__PURE__*/_jsx(AddOnsList, {})
        })
      })]
    })]
  });
};